<template>
  <div style="overflow: hidden;">
    <el-top-nav-menu-4
      :companyTitle="$t('basicLayout.title')"
      :logoIsShow="false"
      :dashboard="shopPage"
      :showInput="false"
      :Menu4Href="Menu4Href"
      ref="topNavMenu"
      :logo="LOGO"
      width="1180px"
      padding="0"
      :showHelp="showHelp"
    >
      <div class="ldg" @click="goser">
        <span class="dpng">{{$t('page.applyUsername.btn.msg10')}}</span>
        <div class="los">
          <img :src="leftgg" />
        </div>
      </div>
    </el-top-nav-menu-4>
    <div class="content">
      <el-form ref="form" class="form mkl" :model="form" :rules="rules">
        <span class="fastReg"
        >{{$t('page.mobileValidate.title.title')}}</span
        >

        <!--<el-form-item prop="mobile">-->
          <!--<el-input-->
            <!--class="inputPad"-->
            <!--:placeholder="$t('page.mobileValidate.inputPlc.mobile')"-->
            <!--maxlength="11"-->
            <!--v-model="form.mobile"-->
          <!--&gt;</el-input>-->
          <!--&lt;!&ndash; <el-select v-model="select" class="inputBe2">-->
            <!--<el-option v-for="(v, key) inS country" :key="key" :label="v.name" :value="v.code"></el-option>-->
          <!--</el-select>&ndash;&gt;-->
          <!--<span class="inputBe">-->
            <!--+86-->
            <!--<img-->
              <!--:src="imgUrl"-->
              <!--style="display:inline;padding-left:5px;padding-bottom:2px;"-->
              <!--alt-->
            <!--/>-->
          <!--</span>-->
        <!--</el-form-item>-->

        <!--<el-form-item prop="inputAuthCode">-->
          <!--<div class="inputAuthCodeBox">-->
            <!--<el-input-->
              <!--maxlength="6"-->
              <!--class="inputAuthCode"-->
              <!--:placeholder="$t('page.applyUsername.inputPlc.authCodeMsg')"-->
              <!--v-model="form.inputAuthCode"-->
            <!--&gt;</el-input>-->
            <!--<div class="countDown" :class="{'enBtn':!languagezh_cn}" v-show="show" @click="getTestCode">-->
              <!--{{$t('page.mobileValidate.btn.code')}}-->
            <!--</div>-->
            <!--<div class="countDown" ref="countDown" v-show="!show">-->
              <!--{{ second }}s-->
            <!--</div>-->
          <!--</div>-->
        <!--</el-form-item>-->
        <!--<div class="islider" v-if="isCode">-->
          <!--<Slider-->
            <!--@close="isCode = false"-->
            <!--:log="true"-->
            <!--@getImg="getImg"-->
            <!--@validImg="validImg"-->
          <!--&gt;</Slider>-->
        <!--</div>-->
        <el-form-item prop="userNamePhone">
          <div class="diyLabel">{{$t('page.mobileValidate.title1.name')}}</div>
          <el-input
            v-model.trim="form.userName"
            style="width: 500px"
            :placeholder="$t('page.mobileValidate.inputPlc.name')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userPwd">
          <div class="diyLabel">{{$t('page.mobileValidate.title1.psd')}}</div>
          <el-input
            v-model.trim="form.userPwd"
            type="password"
            style="width: 500px"
            :placeholder="$t('page.mobileValidate.inputPlc.psd')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="testNumber" @click="submit">{{$t('page.mobileValidate.btn.sub')}}</div>
      <!--<div class="wdf">-->
        <!--<div class="cvb">-->
          <!--<div class="pmp c1">Q</div>-->
          <!--<span class="jklo">{{$t('page.mobileValidate.msg.q')}}</span>-->
        <!--</div>-->
        <!--<div class="cvb">-->
          <!--<div class="pmp c2">A</div>-->
          <!--<span class="jklo1"-->
          <!--&gt;{{$t('page.mobileValidate.msg.a')}}-->
          <!--</span>-->
        <!--</div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/utils";
import {
  sendVerificationCode,
  checkSupplierInfoByMobile
} from '@/api/supRegister';
import { getImageVerifyCode} from '@/api/register-shop'
import Setting from "@/config/index";
import Cookies from "js-cookie";
import Slider from "../../common/slider";
const savedLocaleKey = Setting.i18n.cookieLable;

export default {
  name: "mobileValidate",
  components: {
    Slider
  },
  props: ['flag'],
  data () {
    const mobileRules = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error(window.$t('page.mobileValidate.inputRules.mobile')))
      } else {
        callback()
      }
    }
    const inputAuthCodeRules = (rule, value, callback) => {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error(window.$t('page.mobileValidate.inputRules.code')))
      } else {
        callback()
      }
    }
    return {
      shopPage: addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      LOGO: require('@/assets/images/logoS.png'),
      leftgg: require('@/assets/images/llop.png'),
      Menu4Href: true,
      showHelp: false,
      second: 0,
      show: true,
      timer: '',
      imgUrl: require('@/assets/images/arrows.png'),
      rules: {
        mobile: [
          { required: true, message: window.$t('page.mobileValidate.inputPlc.mobile'), trigger: 'blur' },
          { validator: mobileRules, trigger: 'blur' }
        ],
        inputAuthCode: [
          { required: true, message: window.$t('page.applyUsername.inputPlc.authCodeMsg'), trigger: 'blur' }
        ]
      },
      form: {
        userName:'',
        userPwd:'',
        // mobile: '',
        // inputAuthCode: ''
      },
      localLang: Cookies.get(savedLocaleKey),
      isCode: false, // 拼图滑块
    }
  },
  activated() {
    console.log(this.localLang)
    if(this.localLang !== 'zh-cn') {
      this.rules.mobile = [{ required: true, message: window.$t('page.mobileValidate.inputPlc.mobile'), trigger: 'blur' }]
    }
  },
  deactivated() {
    this.form = {
      mobile: '',
      inputAuthCode: ''
    }
  },
  watch: {},
  created () {
    // getPmcAdress({ addressCode: "100000" }).then(res => {
    //   console.log(res, "区域");
    // });
  },
  mounted () {},
  methods: {
    goser () {
      this.$router.push({
        path:'/regView/mobileValidate'
      })
    },
    getCode (blcokLeft,id,callback) {
      if (this.form.mobile) {
        if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile)) {
          console.log(2123321321)
          this.$refs.countDown.style.backgroundColor = 'rgba(242, 242, 242, 1)'
          this.$refs.countDown.style.color = 'rgba(153, 153, 153, 1)'
          this.$refs.countDown.style.cursor = 'no-drop'
          const TIME_COUNT = 59
          this.second = TIME_COUNT
          this.show = false
          console.log(this.show)
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            if (this.second > 0 && this.second <= TIME_COUNT) {
              this.second--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)

          sendVerificationCode(
            {
              // generateSmsVerificationCodeReqBO: {phoneNumbers: this.form.mobile} ,
              // captchaVail: { x: blcokLeft, catuid: id }
              phoneNumbers: this.form.mobile
            })
            .then(res => {
              this.isCode = false
              if (res.data.code === '0') {
                callback({data:true});
                this.isCode = false;
                this.show = false;
                // if (res.data.message.includes('成功')) {
                //   this.isCode = true
                // } else {
                //   this.show = true
                //   clearInterval(this.timer)
                //   this.second = 59

                //   this.$message({
                //     message: res.data.message,
                //     type: 'error',
                //     offset: this.messageHeight
                //   })
                // }
              } else {
                callback({data:false,message:res.data.message});
                this.isCode = true;
                this.show = true;
                clearInterval(this.timer)
                this.second = 59
                this.$message({
                  message: res.data.message,
                  type: 'error',
                  offset: this.messageHeight
                })
              }
            })
            .catch(errMessage => {
              this.show = true
              clearInterval(this.timer)
              this.second = 59
            })
        }
      } else {
        this.$message({
          message: window.$t('page.mobileValidate.inputPlc.mobile'),
          type: 'error',
          offset: this.messageHeight
        })
      }
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          checkSupplierInfoByMobile({
            registMobile: this.form.mobile,
            ...this.form,
            isShowPageLoading: true
          }).then(res => {
            if(res.data.code === '0' && res.data.data.returnCheckCode === '') {
              if(this.localLang === 'zh-cn') {
                this.$router.push({
                  path: '/regView/supRegDetail',
                  query: {
                    supInfoApplyId: res.data.data.supInfoApplyId,
                    tempOrFormalFlag: res.data.data.tempOrFormalFlag,
                    supAuditId: res.data.data.supAuditId,
                    registMobile: this.form.mobile
                  }
                })
              } else {
                this.$router.push({
                  path: '/regView/foreignSupRegDetail',
                  query: {
                    supInfoApplyId: res.data.data.supInfoApplyId,
                    tempOrFormalFlag: res.data.data.tempOrFormalFlag,
                    supAuditId: res.data.data.supAuditId,
                    registMobile: this.form.mobile
                  }
                })
              }
            } else if (res.data.code === '0' && res.data.data.returnCheckCode === 'RP_SP0044') {
              this.$message.error(window.$t('page.mobileValidate.msg.msg1'))
            }else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then((res) => {
        callback(res.data);
      }, error => {
        callback(error);
      });
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.getCode(blcokLeft,id,callback); // 登陆请求方法
    },
    getTestCode () {
      this.$refs['form'].validateField('mobile', (valid) => {
        if (!valid) {
          // if (!this.isPhoneBtnClick) {
            this.isCode= true;
          // }
        }else {
          this.$message({
            message: window.$t('page.mobileValidate.inputPlc.mobile'),
            type: 'error',
            offset: this.messageHeight
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.ldg {
  float: right;
  margin-top: 30px;
  cursor: pointer;
}

.dpng {
  font-size: 16px;
  color: #ffffff;
  line-height: 18px;
  float: left;
  margin-right: 10px;
}

.los img {
  width: 100%;
}

.los {
  width: 18px;
  height: 18px;
  float: left;
}

.wdf {
  margin-top: 20px;
}

.cvb {
  width: 500px;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 20px;
}

.jklo {
  font-size: 16px;
  color: #4a4a4a;
  line-height: 20px;
  margin-left: 5px;
  float: left;
  width: 400px;
}

.jklo1 {
  font-size: 16px;
  color: #9b9b9b;
  line-height: 20px;
  margin-left: 5px;
  float: left;
  width: 400px;
}

.pmp {
  float: left;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  width: 20px;
  height: 20px;
  color: white;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  border-top-right-radius: 50%;
}

.c1 {
  background-color: #0089ef;
}

.c2 {
  background-color: #16ba74;
}

html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}

ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

input,
div {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}

/* content */
.content {
  width: 1180px;
  min-height: calc(100vh - 120px);
  background: rgba(255, 255, 255, 1);
  margin: 20px auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 34px;
}

.fastReg {
  font-size: 20px;
  font-family: PingFang-SC;
  font-weight: 800;
  color: rgba(74, 74, 74, 1);
  line-height: 28px;
  display: block;
  padding-bottom: 20px;
}

.regUpload {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  position: absolute;
  top: 228px;
  left: 340px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
}

.codeTxt {
  width: 370px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  position: absolute;
  left: 340px;
  top: 208px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 40px;
}

.codeTxt input {
  color: rgba(74, 74, 74, 1);
}

.countDown {
  width: 110px;
  height: 40px;
  /* background: rgba(242, 242, 242, 1); */
  background-color: #FF142F;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #fff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
}

.testNumber {
  width: 500px;
  height: 40px;
  background: #FF142F;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
}

.codeList li {
  width: 100%;
  height: 100%;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  /* line-height: 18px; */
}

.select {
  width: 67px;
  overflow: hidden;
  margin-top: -2px;
}

.codeList li:hover {
  background: #c7c9cc;
}

.codeList {
  position: absolute;
  left: -1px;
  border: 1px solid #ccc;
  border-top: 0;
  z-index: 99;
  background: #fff;
  width: 297px;
  height: 204px;
  overflow-y: scroll;
  border-radius: 0 0 5px 5px;
  padding: 0;
}

.inputAuthCode {
  width: 380px;
  margin: 0;
}

.codeInfo {
  width: 100%;
  height: 32px;
  padding-left: 10px;
}

.form {
  width: 500px;
}

.inputAuthCodeBox {
  display: flex;
}

/deep/ .el-button.el-button--primary-font-mini {
  background-color: #ff142f;
  border-color: #ff142f;
}

/deep/ .el-button.el-button--default-mini:hover {
  color: #ff142f;
}

.mkl {
  margin-top: 80px;
}
</style>
<style scoped>
/deep/
.el-top-nav-menu4
.sub-menu-wrapper-wrapper
.sub-menu-wrapper
.logo-container
img {
  display: inline-block;
  vertical-align: middle;

  border: none;
}

/deep/ .el-input__inner {
  height: 40px;
  padding-left: 10px;
  line-height: 40px;
}

/deep/ .el-input-group__prepend {
  background: rgba(255, 255, 255, 1);
  margin-bottom: 10px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}

/deep/ .el-icon-caret-bottom {
  line-height: 3;
}

/deep/ .el-input-group {
  position: relative;
}

/deep/ .inputBe {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: transparent;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 1px;
  top: 1px;
}

/deep/ .inputBe2 {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: #fff;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 0px;
}

/deep/ .inputBe2 .el-input__inner:hover {
  border: 1px solid #dcdfe6;
}

/deep/ .inputPad .el-input__inner {
  padding-left: 82px;
}

/deep/ .el-select {
  border: 1px solid rgba(204, 204, 204, 1) !important;
}
.islider{
      width: 400px;
      height: 265px;
      background: #FFFFFF;
      border-radius: 4px;
      box-shadow: 0px 4px 6px 0px rgba(201,201,201,0.5), 4px 0px 4px 0px rgba(229,229,229,0.5);
      position:absolute;
      left:230px;
      top: -170px;
    }
.islider::after {
  position: absolute;
  bottom: -11px;
  left:50%;
  content: '';
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, .1);
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left:50%;
  content: '';
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, .2));
}
/deep/ .el-form {
  position: relative;
}
  .enBtn{
    width:185px
  }
</style>

